module.exports = __webpack_public_path__ + "static/img/5.93f2854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-3/5.png
// module id = 0Hcm
// module chunks = 0